<template>
  <img v-if="current_slide" :src="slide_image_url" alt="" class="img-fluid" :style="settings.slide_style">
</template>

<script>
  const NO_END = -1;
  const NO_SLIDE = -1;

  import { is_number } from "../../utils";

  export default {
    data() {
      return {
        current_slide_data: {
          index: 0,
          start_time: 0,
          end_time: null
        },
      }
    },
    props: {
      slides: {
        type: Array,
        required: true
      },
      settings: {
        type: Object,
        required: true
      },
      current_time: {
        type: Number,
        required: true
      }
    },
    created: function(){
      this.find_and_set_current_slide();
    },
    watch: {
      current_time: function() {
        this.check_for_slide_update();
      }
    },
    computed: {
      slide_image_url: function(){
        return this.current_slide.slide.url
      },
      current_slide: function(){
        if (this.current_slide_data.index !== NO_SLIDE){
          return this.sanitized_slides[this.current_slide_data.index]
        }
      },
      sanitized_slides: function(){
        return this.slides.map((slide, index) => {
          if (is_number(slide.end_time)){
            return slide
          }else{
            const next_slide = this.slides[index + 1];

            if (next_slide && is_number(next_slide.start_time)){
              return { ...slide, end_time: next_slide.start_time }
            }else{
              return { ...slide, end_time: NO_END }
            }
          }
        })
      }
    },
    methods: {
      set_current_slide_data: function(index){
        const current_slide = this.sanitized_slides[index];

        this.current_slide_data = {
          end_time: current_slide.end_time,
          start_time: current_slide.start_time,
          index
        }
      },
      find_current_slide_index: function(){
        for (let index = 0; index < this.sanitized_slides.length; index ++){
          const slide = this.sanitized_slides[index];

          if (is_number(slide.start_time) && this.current_time >= slide.start_time){
            if (slide.end_time === NO_END || slide.end_time > this.current_time){
              return index
            }
          }
        }

        return NO_SLIDE;
      },
      find_next_slide_index: function(){
        for (let index = 0; index < this.sanitized_slides.length; index ++){
          const slide = this.sanitized_slides[index];

          if (is_number(slide.start_time) && slide.start_time > this.current_time){
            return index
          }
        }

        return NO_SLIDE;
      },
      find_and_set_current_slide: function(){
        const current_index = this.find_current_slide_index();

        if (current_index === NO_SLIDE){
          const next_index = this.find_next_slide_index();
          const end_time = next_index === NO_SLIDE ? NO_END : this.sanitized_slides[next_index].start_time;

          this.current_slide_data = {
            end_time,
            start_time: this.current_time,
            index: NO_SLIDE
          }
        }else{
          this.set_current_slide_data(current_index)
        }
      },
      check_for_slide_update(){
        if ((this.current_time < this.current_slide_data.start_time) ||
          (this.current_slide_data.end_time !== NO_END && this.current_time > this.current_slide_data.end_time)) {
          this.find_and_set_current_slide()
        }
      }
    }
  }
</script>